import { gql } from '@apollo/client'

export const SHOP_APPLIED_TIP_VARIANT_FRAGMENT = gql`
  fragment ShopAppliedTipVariant on ShopAppliedTipVariant {
    amount
    amountFormatted
    id
  }
`
